var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "card js-card filtered-item" }, [
    _c(
      "div",
      {
        staticClass: "cursor-pointer",
        class: {
          "card__img-holder card__img-holderTs picturefill-background":
            _vm.brandName === _vm.Brand.Travelsphere,
          "card__img-holder picturefill-background":
            _vm.brandName !== _vm.Brand.Travelsphere,
        },
        on: { click: _vm.handleExploreClick },
      },
      [
        _c("picture", [
          _c("source", {
            attrs: {
              srcset: `${_vm.item.image.smallUrl}?format=webp`,
              media: "(max-width: 575px)",
              type: "image/webp",
            },
          }),
          _vm._v(" "),
          _c("source", {
            attrs: {
              srcset: `${_vm.item.image.mediumUrl}?format=webp`,
              media: "(min-width: 576px)",
              type: "image/webp",
            },
          }),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: `${_vm.item.image.smallUrl}?format=webp`,
              alt: _vm.item.name,
              loading: "lazy",
            },
          }),
        ]),
        _vm._v(" "),
        _vm.item.tourSummary.offerText
          ? _c("div", { staticClass: "offer-tag" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.item.tourSummary.offerText) + "\n    "
              ),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "card__content",
        class: { card__contentTs: _vm.brandName === _vm.Brand.Travelsphere },
      },
      [
        _c("div", { staticClass: "card__inner" }, [
          _c("div", { staticClass: "card__header" }, [
            _c("span", {
              staticClass: "card__subtitle",
              class: {
                cardSubtitleTs: _vm.brandName === _vm.Brand.Travelsphere,
              },
              domProps: { innerHTML: _vm._s(_vm.item.departureDatesFormatted) },
            }),
            _vm._v(" "),
            _c("h3", { staticClass: "card__title" }, [
              _c(
                "a",
                {
                  class: {
                    cardTitleTs: _vm.brandName === _vm.Brand.Travelsphere,
                  },
                  attrs: { href: _vm.item.tourLink.url, target: "_blank" },
                  on: { click: _vm.handleExploreClick },
                },
                [_vm._v(_vm._s(_vm.item.name))]
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.brandName !== _vm.Brand.Travelsphere
            ? _c("div", { staticClass: "tour-price" }, [
                _c("strong", { staticClass: "tour-price__days" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.item.tourSummary.fromDays) +
                      "\n          days from\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "tour-price__value" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.item.tourSummary.fromPriceFormatted) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm.item.tourSummary.wasFromPrice > 0
                  ? _c("span", { staticClass: "tour-price__was-value" }, [
                      _vm._v("\n          was\n          "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.item.tourSummary.wasPriceFormatted)),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.description
            ? _c("div", { staticClass: "card__description" }, [
                _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.item.description) },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.brandName === _vm.Brand.Travelsphere
            ? _c(
                "div",
                {
                  staticClass: "tour-price",
                  class: {
                    "tour-priceTs": _vm.brandName === _vm.Brand.Travelsphere,
                  },
                },
                [
                  _c("span", { staticClass: "tour-price__days" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.item.tourSummary.fromDays) +
                        "\n          days from\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("strong", { staticClass: "tour-price__value" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.item.tourSummary.fromPriceFormatted) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.item.tourSummary.wasFromPrice > 0
                    ? _c("span", { staticClass: "tour-price__was-value" }, [
                        _vm._v("\n          was\n          "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.item.tourSummary.wasPriceFormatted)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card__footer card__footer_sm filter-buttons" },
          [
            _vm.item.mapLink
              ? _c(
                  "a",
                  {
                    staticClass:
                      "btn js-modal filter-buttons-width btn--outline-gray-color_sm",
                    class: {
                      "btn--outline-gray-color resultCardMapTs":
                        _vm.brandName === _vm.Brand.Travelsphere,
                      "btn-tertiary": _vm.brandName !== _vm.Brand.Travelsphere,
                    },
                    attrs: { href: _vm.item.mapLink.url },
                  },
                  [_vm._v(_vm._s(_vm.item.mapLink.name))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn card__btn filter-buttons-width",
                class: {
                  resultCardTs: _vm.brandName === _vm.Brand.Travelsphere,
                },
                attrs: { target: "_blank", href: _vm.item.tourLink.url },
                on: { click: _vm.handleExploreClick },
              },
              [_vm._v(_vm._s(_vm.item.tourLink.name))]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }